import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import StudyDesignView from '../design/StudyDesignView';
import StudyDesignTabState from './StudyDesignTabState';

export default class StudyDesignTabView extends Backbone.View<StudyDesignTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override render(): this {
    const id = this.model.studyId();
    const studyType = this.model.studyType();
    renderToDOM(<StudyDesignView studyId={id} studyType={studyType} />, this.el);
    return this;
  }

  override remove(): Backbone.View<StudyDesignTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

StudyDesignTabView.initClass();
